export const AUTH = 'auth';

const LocalStorage = {
  setAuth(login) {
    return localStorage.setItem(AUTH, login);
  },
  getAuth() {
    return localStorage.getItem(AUTH);
  },
  removeAuth() {
    return localStorage.removeItem(AUTH);
  },
  isMulticolliMerchant() {
    const auth = localStorage.getItem(AUTH);
    if (auth) {
      const authData = JSON.parse(auth);
      if (authData.is_multicolli) {
        return true;
      }
    }

    return false;
  },
};

export default LocalStorage;
